import styled from 'styled-components'

const StyledShadow = styled.div`
  background: rgb(150, 150, 150, 0.3);
  background: linear-gradient(180deg, rgb(150, 150, 150, 0.3) 0%, rgba(1, 1, 2, 0) 100%);
`

const Shadow: React.FC<{ className?: string; bottom?: boolean }> = ({ className, bottom }) => {
  return <StyledShadow className={`h-16 z-[1] absolute w-full bg-black ${bottom ? 'bottom-0 rotate-180' : 'top-0'} ${className}`}></StyledShadow>
}

export default Shadow
